import { ISpPageContext } from '@ms/odsp-datasources/lib/interfaces/ISpPageContext';
import AriaLoggerCore from '@ms/odsp-utilities/lib/aria/AriaLoggerCore';
import { SPOTenantTokens } from '@ms/spo-core/lib/Tenants';
import Guid from '@ms/odsp-utilities/lib/guid/Guid';
import { AccountType as AccountTypeEnum } from '@ms/odsp-utilities/lib/logging/EventBase';
import {
  IItemCacheDispatch, IItemCacheThunkAction
} from '@ms/items-view/lib/private/store/actions/ItemCacheActions';
import { loggerFacet } from '@ms/items-view/lib/private/facets/LoggerFacets';
import { readConfiguration } from '@ms/items-view/lib/private/operations/configuration/readConfiguration';

export function initAriaLogging(pageContext: ISpPageContext): IItemCacheThunkAction<Promise<void>> {
  return async (dispatch: IItemCacheDispatch) => {
    const {
      spLoggerConfiguration
    } = dispatch(readConfiguration({
      spLoggerConfiguration: loggerFacet
    }));

    if (spLoggerConfiguration) {
      const {
        reportRUMOnePerfData = true
      } = spLoggerConfiguration;
      if (!reportRUMOnePerfData) {
        return;
      }
    }

    const {
      aria
    } = await import(/* webpackChunkName: 'ariawrapper' */'@ms/telemetry-addon-aria/lib/AriaWrapper');
    const scenarioId = spLoggerConfiguration && spLoggerConfiguration.scenarioId;
    const workload = `${scenarioId || 'Unknown'}.ItemsView`;

    if (!AriaLoggerCore.isInitialized(aria)) {
      const {
        isAnonymousGuestUser,
        currentUICultureName,
        systemUserKey,
        userLoginName,
        siteSubscriptionId,
        farmLabel,
        env = 'devbox'
      } = pageContext;
      let token;
      switch (env.toLowerCase()) {
        case 'edog':
        case 'prodbubble':
          token = SPOTenantTokens.ppe;
          break;
        case 'prod':
        case 'dprod':
          token = SPOTenantTokens.prod;
          break;
        default:
          token = SPOTenantTokens.ppe;
          break;
      }
      AriaLoggerCore.Init(
        token,
        {
          isAuthenticated: !isAnonymousGuestUser,
          market: currentUICultureName,
          session: Guid.generate(),
          version: '',
          manifest: '',
          userId: systemUserKey,
          accountType: userLoginName ? AccountTypeEnum.Business : AccountTypeEnum.BusinessAnonymous,
          siteSubscriptionId: siteSubscriptionId,
          farmLabel: farmLabel,
          environment: env,
          workload: workload,
          disableCookies: isAnonymousGuestUser
        },
        aria);
    }
  };
}
